// offers page handle
(() => {
  const cardStates = new Map();

  function applyCardState(card, productHandle, variantId) {
    const priceContainer = card.querySelector('.price-container');
    const addToCartBtn = card.querySelector('.add-to-cart-button');
    const variantButtons = card.querySelectorAll('.variant-button');

    if (priceContainer) {
      priceContainer.setAttribute('data-product-handle', productHandle);
      priceContainer.setAttribute('data-variant-id', variantId);
    }

    if (addToCartBtn) {
      addToCartBtn.setAttribute('data-product-handle', productHandle);
      addToCartBtn.setAttribute('data-variant-id', variantId);
    }

    variantButtons.forEach(btn => {
      const btnVariantId = btn.getAttribute('data-variant-id');
      if (btnVariantId === variantId) {
        btn.classList.add('selected');
        btn.setAttribute('aria-checked', 'true');
      } else {
        btn.classList.remove('selected');
        btn.setAttribute('aria-checked', 'false');
      }
    });
  }

  function restoreAllCardStates() {
    cardStates.forEach((state, cardElement) => {
      if (document.contains(cardElement)) {
        applyCardState(cardElement, state.productHandle, state.variantId);
      }
    });
  }

  function init() {
    const cards = document.querySelectorAll('.product-card');

    cards.forEach((card) => {
      const link = card.querySelector('a[href*="/products/"]');
      
      if (!link) return;

      const productUrl = link.getAttribute('href');
      const productHandle = productUrl.split('/products/')[1]?.split('?')[0];

      if (!productHandle) return;

      const activeVariantBtn = card.querySelector('.variant-button.selected');
      const initialVariantId = activeVariantBtn ? activeVariantBtn.getAttribute('data-variant-id') : null;

      if (initialVariantId) {
        cardStates.set(card, {
          productHandle,
          variantId: initialVariantId
        });
        applyCardState(card, productHandle, initialVariantId);
      }

      const variantButtons = card.querySelectorAll('.variant-button');

      variantButtons.forEach((btn) => {
        if (btn.dataset.listenerAttached) return;
        btn.dataset.listenerAttached = 'true';

        btn.addEventListener('click', function() {
          const variantId = this.getAttribute('data-variant-id');

          cardStates.set(card, {
            productHandle,
            variantId
          });

          applyCardState(card, productHandle, variantId);

          if (window.Abra && typeof window.Abra.render === 'function') {
            window.Abra.render();
            
            setTimeout(() => {
              restoreAllCardStates();
            }, 50);
          }
        });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  const observer = new MutationObserver(() => {
    init();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
})();

// shoppable-feed-card handle
(() => {
  const applyHandles = () => {
    document.querySelectorAll('.shoppable__feed--card').forEach(card => {
      const productCard = card.querySelector('product-card[product-handle]');
      if (productCard) {
        const handle = productCard.getAttribute('product-handle');
        card.setAttribute('data-product-handle', handle);
        const priceWrapper = card.querySelector('.product-price__wrapper');
        if (priceWrapper) {
          priceWrapper.setAttribute('data-product-handle', handle);
        }
      }
    });
    if (window.Abra) {
      window.Abra.render();
    }
  };

  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.addedNodes.length) {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === 1) {
            if (node.classList?.contains('swiper-wrapper') || node.querySelector?.('.swiper-wrapper')) {
              applyHandles();
            }
          }
        });
      }
    });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  applyHandles();
})();

// quick-view modal variants handle
(() => {
  let currentProductHandle = null;

  function updateVariant(productHandle, variantId) {
    const drawer = document.querySelector('.drawer__wrapper[data-abra-container]');
    if (!drawer) return;

    const priceWrapper = drawer.querySelector('.product__quick__view__price__wrapper');
    const priceContainer = drawer.querySelector('.price-container');
    const formInput = drawer.querySelector('#product-form-product-quick-view input[name="id"]');
    const addToCartBtn = drawer.querySelector('#product-form-product-quick-view button[type="submit"]');

    if (priceWrapper) {
      priceWrapper.setAttribute('data-product-handle', productHandle);
      priceWrapper.setAttribute('data-variant-id', variantId);
    }

    if (priceContainer) {
      priceContainer.setAttribute('data-product-handle', productHandle);
      priceContainer.setAttribute('data-variant-id', variantId);
    }
    
    if (formInput) {
      formInput.value = variantId;
    }

    if (addToCartBtn) {
      addToCartBtn.setAttribute('data-variant-id', variantId);
    }
    
    if (window.Abra?.render) {
      window.Abra.render();
    }
  }

  function setupDrawer() {
    const drawer = document.querySelector('.drawer__wrapper[data-abra-container]');
    if (!drawer) return;

    const productLink = drawer.querySelector('a[href*="/products/"]');
    if (!productLink) return;

    currentProductHandle = productLink.getAttribute('href').split('/products/')[1]?.split('?')[0];
    if (!currentProductHandle) return;

    const checkedInput = drawer.querySelector('.variant-pills-wrapper input[type="radio"][data-variant-id]:checked');
    if (checkedInput) {
      const initialVariantId = checkedInput.getAttribute('data-variant-id');
      updateVariant(currentProductHandle, initialVariantId);
    }

    const variantWrapper = drawer.querySelector('.variant-pills-wrapper');
    if (variantWrapper && !variantWrapper.dataset.drawerListenerAttached) {
      variantWrapper.dataset.drawerListenerAttached = 'true';
      
      variantWrapper.addEventListener('change', function(e) {
        if (e.target.type === 'radio' && e.target.hasAttribute('data-variant-id')) {
          const variantId = e.target.getAttribute('data-variant-id');
          if (currentProductHandle && variantId) {
            setTimeout(() => {
              updateVariant(currentProductHandle, variantId);
            }, 800);
          }
        }
      });

      variantWrapper.addEventListener('click', function(e) {
        if (e.target.tagName === 'LABEL') {
          const input = document.getElementById(e.target.getAttribute('for')?.trim());
          if (input && input.type === 'radio' && input.hasAttribute('data-variant-id')) {
            const variantId = input.getAttribute('data-variant-id');
            if (currentProductHandle && variantId) {
              setTimeout(() => {
                updateVariant(currentProductHandle, variantId);
              }, 800);
            }
          }
        }
      });
    }
  }

  const observer = new MutationObserver(() => {
    if (document.querySelector('.drawer-active .variant-pills-wrapper')) {
      setupDrawer();
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });

  if (document.querySelector('.drawer-active')) {
    setupDrawer();
  }
})();